<template>
  <v-card>
    <v-card-title primary-title>
      <div class="headline blue--text">{{title}}</div>
    </v-card-title>
    <v-container>
      <v-layout row wrap px-3>
        <v-flex xs12 text-xs-center style="margin-top: -24px;">
          <span class="grey--text" v-html="loadingText"></span>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            label="Descrição"
            auto-grow
            rows="1"
            v-model="record_info.notes"></v-textarea>
        </v-flex>
        <v-flex xs12>
          <v-select
            v-model="record_info.professional_id"
            :items="professionalsSelect"
            label="Responsável"></v-select>
        </v-flex>
        <v-flex xs12 align-center justify-space-between v-if="showCarForm">
          <div class="subheading blue--text">Informações do carro</div>
        </v-flex>
        <v-flex xs12 align-center justify-space-between v-if="showCarForm">
          <v-container>
            <v-layout column>
              <v-flex>
                <v-text-field v-model="car_info.maker" label="Fabricante"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="car_info.model" label="Modelo"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="car_info.year" label="Ano"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="car_info.plate" label="Placa"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12 align-center justify-space-between v-if="!showCarForm">
          <v-select
            v-model="record_info.car_id"
            :items="carsSelect"
            label="Carro"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-select
            v-model="record_info.status"
            :items="statuses"
            label="Situação"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="white" class="grey--text" @click="$router.go(-1)">Cancelar</v-btn>
      <v-btn color="blue darken-2" dark @click="saveRecord()">{{saveBtnLabel}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  name: "OrderForm",
  components: { },
  props: {
    record: Object,
    cars: Array,
    professionals: Array
  },
  data() {
    return {
      record_info: {},
      car_info: {},
      show_car_form: false,
      loading: false,
      statuses: [
        { text: 'Aguardando', value: 'pending'},
        { text: 'Em andamento', value: 'in_progress'},
        { text: 'Finalizado', value: 'finished'},
        { text: 'Entregue', value: 'delivered'}
      ]
    }
  },
  computed: {
    loadingText() {
      return this.loading ? 'Carregando...' : '&nbsp;'
    },
    showCarForm() {
      return this.show_car_form
    },
    professionalsSelect() {
      return this.professionals.map(p => { return {text: p.name, value: `${p.id}`} })
    },
    carsSelect() {
      return this.cars.map(p => { return {text: `${p.maker} ${p.model} ${p.year}`, value: `${p.id}`} })
    },
    title() {
      return this.updateState ? 'Cadastro do Serviço' : 'Cadastrar Serviço'
    },
    clientId() {
      const route_check_result = pathToRegexp('/cliente/:id/servico/:service_id*').exec(this.$route.path)
      return route_check_result === null ? null : (route_check_result[1] == 'novo' ? null : route_check_result[1]);
    },
    serviceId() {
      const route_check_result = pathToRegexp('/cliente/:id/servico/:service_id*').exec(this.$route.path)
      return route_check_result === null ? null : (route_check_result[2] == 'novo' ? null : route_check_result[2]);
    },
    updateState() {
      return this.serviceId ? (this.serviceId === 'novo' ? false : true) : false
    },
    saveBtnLabel() {
      return (this.updateState) ? 'Atualizar' : 'Salvar'
    }
  },
  methods: {
    checkRoute(string_route) {
      return pathToRegexp(string_route).exec(this.$route.path) !== null;
    },
    saveRecord() {
      let successCallback = (response) => {
        this.$router.go(-1)
      }

      let errorCallback = (response) => {
        debugger
      }

      let payload = {
        customer_id: this.record_info.customer_id,
        professional_id: this.record_info.professional_id,
        car_id: this.record_info.car_id,
        status: this.record_info.status,
        notes: this.record_info.notes,
      }

      if (this.updateState) {
        if (payload.status === 'in_progress') {
          if (this.record_info.started_at === null) {
            payload.started_at  = Date.now()
          }
        }
        if (payload.status === 'finished') {
          if (this.record_info.finished_at === null) {
            payload.finished_at  = Date.now()
          }
        }
        this.$http.put(`${this.$root.base_url}/orders/${this.serviceId}`, payload, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
      } else {
        // only required on creation
        payload.total_value = this.record_info.total_value
        payload.created_at  = this.record_info.created_at

        this.$http.post(`${this.$root.base_url}/orders`, payload, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
      }
    },
    loadRecord() {
      this.loading = true

      let successCallback = (response) => {
        if (response.body.data) {
          this.loading = false
          this.record_info = response.body.data[0]
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      this.$http.get(`${this.$root.base_url}/orders/${this.serviceId}`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
    }
  },
  created() {
    this.$root.$on('CUSTOMER_CARS_LOADED', (loaded_cars) => {
      if ((this.serviceId === null) && (loaded_cars.length === 0)) {
        this.show_car_form = true
      }
    })
  },
  mounted() {
    this.record_info = this.record
    if (typeof this.record.id !== 'undefined') {
      this.loading = false
    }
    if ((this.serviceId) && (typeof(this.record_info.id) === 'undefined')) {
      this.loadRecord()
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mecanica/OrderForm.vue